
















// vendor
import { defineComponent, computed, PropType } from "@vue/composition-api";
// local
import { CognitiveTestData } from "../ts/types/CognitiveTestData";

const testTypes = [
	{ text: "-", value:null },
	{ text: "SART", value: "SART" }
];

export default defineComponent({

	props:{
		data:{
			type:Object as PropType<CognitiveTestData>,
			required:true
		}
	},
	setup(props){

		const testType = computed({
			get: () => props.data.testType,
			set: (v:string|null) => props.data.testType = v
		});

		return {
			testTypes,
			testType
		};
	}


});

